module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgzMiAyNTZhNjQgNjQgMCAwIDEgNjMuOCA1OS4yTDg5NiAzMjB2NTEyYTY0IDY0IDAgMCAxLTU5LjIgNjMuOEw4MzIgODk2SDMyMGE2NCA2NCAwIDAgMS02My44LTU5LjJMMjU2IDgzMlYzMjBhNjQgNjQgMCAwIDEgNTkuMi02My44TDMyMCAyNTZoNTEyeiBtMCA2NEgzMjB2NTEyaDUxMlYzMjB6IG0tMTkyLTE5MmEzMiAzMiAwIDAgMSAzLjcgNjMuOEw2NDAgMTkySDE5MnY0NDhhMzIgMzIgMCAwIDEtNjMuOCAzLjdMMTI4IDY0MFYxOTJhNjQgNjQgMCAwIDEgNTkuMi02My44TDE5MiAxMjhoNDQ4eiIgZmlsbD0iIzAiIHAtaWQ9IjI1MjMiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Copy 2-outlined.svg
// module id = oBx0
// module chunks = 75